import { post } from '@/api/core'

import { MemberVerifycodeGetReq } from './types'

export type { MemberVerifycodeGetReq, MemberVerifycodeGetType } from './types'

/**
 * 获取手机验证码
 * @description https://api.yinnho.cn/api.php?do=member_verifycode_get&help
 *
 * @param data 请求参数
 */
export function member_verifycode_get (data: MemberVerifycodeGetReq) {
  return post('member_verifycode_get', data)
}
